import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import '@/plugins';
import vuetify from '@/plugins/vuetify';
import http from "@/http";

declare const window;

Vue.mixin({
  computed: {
    console: () => console
}
})

Vue.prototype.$http = http;

Vue.prototype.$colors = {
  green: '#596034',
  blue: '#0F70B7',
  red: '#601312',
};

Vue.config.productionTip = false;

window.vue = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
